import {
  baseGetters,
  baseMutations,
  createBaseActions,
  createBaseState
} from '@/store/modules/entries/base'

const baseActions = createBaseActions({
  entryType: 'account-transactions'
})

const initAccountTransactionState = () => ({
  ...createBaseState(),
  search: ''
})

const accountTransactionMutations = {
  ...baseMutations,
  clearAllData: (state) => {
    Object.assign(state, { ...createBaseState(), search: '' })
  }
}

const accountTransactionGetters = {
  ...baseGetters
}

export const accountTransactionActions = {
  ...baseActions
}

export const accountTransactionModule = {
  namespaced: true,
  state: initAccountTransactionState,
  getters: accountTransactionGetters,
  mutations: accountTransactionMutations,
  actions: accountTransactionActions
}

export default accountTransactionModule
